import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { PageTreeMacroRendererProps } from '../src/PageTreeMacroRenderer.tsx';

export type { PageTreeMacroParams } from '../src/PageTreeMacroRenderer.tsx';

export const PageTreeMacroHandler: LoadableType<PageTreeMacroRendererProps> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageTreeMacro" */ '../src/PageTreeMacroRenderer.tsx'
			)
		).PageTreeMacroRenderer,
});
